import React, { useEffect, useState } from 'react'
import PlaylistResultCard from '../CardStyles/PlaylistResultCard'
import { ResultsCount } from '../common/TopResultsSectionHeader'
import SortToggleFlexBox from '../common/SortToggleFlexBox'
import SearchSorting from 'components_v2/common/MenuDialog'
import styledComponents from 'styled-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { css } from '@styled-system/css'
import { Box } from 'ui/acro'
import axios from 'axios'
import AloMovesAnimation from '../common/AloMovesAnimation'

const PlaylistPage = styledComponents(Box)`
${css({
  // prevents scrollbars from showing
  '.infinite-scroll-component': {
    overflow: 'hidden !important'
  },
  '.playlist-grid': {
    display: 'grid',
    gridTemplateColumns: [
      'repeat(2, 1fr)',
      'repeat(5, 1fr)',
      'repeat(5, 1fr)',
      'repeat(5, 1fr)'
    ],
    gap: ['15px', '16px', '22px', '25px'],
    mb: '57px'
  }
})}
`

const PlaylistResultsPage = ({ query }) => {
  const batchSize = 20
  const [sorting, setSorting] = useState('')
  const [data, setData] = useState([])
  const [hitCount, setHitCount] = useState(0)
  const [offset, setOffset] = useState(0)
  const [hasMore, setHasMore] = useState(false)
  const [refresh, setRefresh] = useState(0)

  const sort = (value) => {
    setSorting(value)
    setOffset(0)
    setData([])
    setRefresh(refresh + 1)
  }

  const fetchData = async () => {
    try {
      const params = { q: query, from: offset, sort: sorting, size: batchSize }
      const res = await axios.get(`api/v2/search/playlists`, { params })
      if (res && res.data && res.data.top) {
        setHitCount(res.data.result_count)
        setData((prevData) => [...prevData, ...res.data.top])

        if (res.data.top.length >= batchSize) {
          setHasMore(true)
          setOffset(res.data.top.length + offset)
        } else {
          setHasMore(false)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    fetchData()
  }, [refresh])

  const showSorting = hitCount > 3

  if (data && hitCount > 0) {
    return (
      <PlaylistPage>
        <SortToggleFlexBox
          flexDirection={['column-reverse', 'row', 'row', 'row']}
        >
          <ResultsCount>
            {hitCount} {hitCount !== 1 ? `playlists` : `playlist`}
          </ResultsCount>
          {showSorting && (
            <SearchSorting applied={sort} location='search_playlists' />
          )}
        </SortToggleFlexBox>
        <InfiniteScroll
          className='playlist-grid'
          dataLength={data.length}
          next={() => {
            fetchData()
          }}
          hasMore={hasMore}
          loader={<AloMovesAnimation />}
        >
          {data.map((item, idx) => (
            <PlaylistResultCard
              key={idx}
              title={item.title && item.title}
              author={item.author && item.author}
              uuid={item.uuid && item.uuid}
              classesCount={item.classes_count && item.classes_count}
              thumbnailImage={item.thumbnail_image && item.thumbnail_image}
              followerCount={item.follower_count && item.follower_count}
              altText={item.title && item.title}
            />
          ))}
        </InfiniteScroll>
      </PlaylistPage>
    )
  } else return <></>
}

export default PlaylistResultsPage
